"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyVariables = void 0;
var utils_1 = require("../utils");
var METHODS = [
    'getMatchesByFilters',
    'getMatchesPreviewByFilters',
    'getCategorizer',
];
var modifyVariables = function (method, variables) {
    var newVariables = variables;
    if (METHODS.includes(method)) {
        var variablesWithConvertedDate = utils_1.formatDateBeforeRequest(variables);
        newVariables = variablesWithConvertedDate;
    }
    return newVariables;
};
exports.modifyVariables = modifyVariables;
//# sourceMappingURL=utils.js.map